var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-snackbar',{attrs:{"value":_vm.snackDisplay,"timeout":4000,"color":_vm.snackType},on:{"input":_vm.hideMessage},scopedSlots:_vm._u([{key:"action",fn:function(ref){
var attrs = ref.attrs;
return [_c('v-btn',_vm._b({attrs:{"text":""},on:{"click":_vm.hideMessage}},'v-btn',attrs,false),[_c('v-icon',[_vm._v("mdi-close")])],1)]}}])},[_vm._v(" "+_vm._s(_vm.snackMessage)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }